import { render, staticRenderFns } from "./ProductPriceTable.vue?vue&type=template&id=51468a94&scoped=true"
import script from "./ProductPriceTable.vue?vue&type=script&lang=js"
export * from "./ProductPriceTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51468a94",
  null
  
)

export default component.exports